export default __webpack_public_path__ + "static/ilustration-4-ddec1ed783fea0f8aef9a9f62a279416.png";